import { useState, type ReactNode } from 'react';
import { useArticle } from '../api/queries';
import { Markdown, Modal, Spinner } from './ui';

/**
 * Opens a legal document (a help-center article) in a dialog, so a half-filled form keeps its
 * input. Works the same in the browser and the desktop app.
 */
export function LegalLink({ slug, children }: { slug: string; children: ReactNode }) {
  const [open, setOpen] = useState(false);
  const article = useArticle(open ? slug : undefined);
  return (
    <>
      <button
        type="button"
        className="link-btn"
        onClick={(e) => {
          e.preventDefault();
          setOpen(true);
        }}
      >
        {children}
      </button>
      <Modal open={open} onClose={() => setOpen(false)} wide label={article.data?.title ?? 'Document'}>
        {article.isLoading ? (
          <Spinner />
        ) : article.data ? (
          <>
            <h2 style={{ marginTop: 0 }}>{article.data.title}</h2>
            <Markdown source={article.data.body} />
          </>
        ) : (
          <p className="muted">This document isn't available right now. Please try again later or contact support.</p>
        )}
      </Modal>
    </>
  );
}
